import { IncrementVisitsCount } from '@/services/cardLinkService';
import type { CardLink } from '@/types/card';
import { getUrlForLink } from '@/utils/getUrlForLink';
import { SocialLink } from './SocialLink';
interface CardLinksProps {
  links: CardLink[] | null;
}

export const CardLinks = ({ links }: CardLinksProps) => {
  if (!links || links.length === 0) return null;

  return (
    <div className="grid grid-cols-3 gap-x-4 gap-y-6">
      {links.map(link => {
        const formattedLink = getUrlForLink(link.icon, link.url);
        const handleClick = () => {
          window.open(formattedLink, '_blank');
          IncrementVisitsCount(link.id);
        };

        return <SocialLink key={link.id} link={link} onClick={handleClick} />;
      })}
    </div>
  );
};
